module.exports = __webpack_public_path__ + "img/LLAMA_ILUM.3efe77b5.svg";